import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    background: "#ffffff",
    height: "100%",
  },
  button: {
    marginTop: 16,
  },
  typography: {
    marginTop: theme.spacing(2),
  },
  link: {
    color: "green",
  },
  errorMessage: {
    color: "red",
    paddingTop: "1%",
    textAlign: "center",
  },
  forgotPasswordLink: {
    cursor: "pointer",
    marginTop: 16,
    textDecoration: "underline",
  },
}));

export default useStyles;
